/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAccountInfo32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M15.5 17.5c-2.824 0-5.329.638-6.975 1.193A2.99 2.99 0 006.5 21.532V25.5h10'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M15.5 17.5c-2.761 0-5-3.239-5-6v-1a5 5 0 0110 0v1c0 2.761-2.239 6-5 6z'
      />
      <path
        fill='#6F757C'
        fillRule='evenodd'
        d='M17.5 22c0-2.475 2.025-4.5 4.5-4.5s4.5 2.025 4.5 4.5-2.025 4.5-4.5 4.5a4.513 4.513 0 01-4.5-4.5zm4.33-1.702a.5.5 0 01-.5-.5v-.168a.5.5 0 01.5-.5h.336a.5.5 0 01.5.5v.168a.5.5 0 01-.5.5h-.336zm.016 4.576a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h.288a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-.288z'
      />
    </svg>
  );
}

export default SvgAccountInfo32;
